import { render, staticRenderFns } from "./PapercleanConfigurazioneCategorieEditModalComponent.vue?vue&type=template&id=603b61ce"
import script from "./PapercleanConfigurazioneCategorieEditModalComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneCategorieEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports